import React, { useState } from "react";
import { useNavigate } from "react-router";

import {
  BackArrowIcon,
  ImportCSVIcon,
} from "../../../assets/icons/iconsProvider";
import Button from "../../../shared/components/Buttons/Button";
import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
  routesPathConstants,
  SALE_TRANSACTION_ACTIVITY_TYPES,
  toastType,
  transactionDefaultData,
} from "../../../constants";
import { createCompanyDynamicUrl, customToast } from "../../utility";
import { connect } from "react-redux";

const Topbar = (props) => {
  const {
    key,
    label,
    countChip,
    IconImage,
    buttonType,
    handleClick,
    isDismissAll,
    currentStore,
    handleParkSale,
    isNewSale = false,
    updateTransactionData,
    totalCustomers = 0,
    totalCartItems = 0,
    handleImportCsvClick,
    title = "Dummy Title",
    importCsvButton = false,
    isNewSalePayment = false,
    showDraftModal = () => {},
    isParkSaleDisabled = false,
    sellTradeToggleButton = false,
    isTransactionComplete = false,
    handleDismissAllClick = () => {},
    exportButton = props.exportButton,
    backNavigation = {
      isVisible: false,
      route: null,
      gridState: false,
      scrollRef: 0,
    },
    isGhostButton = {
      isVisible: false,
      handleButtonClick: () => {},
      buttonLabel: EMPTY_STRING,
    },
    isEditShopifyPresetsButton = {
      isVisible: false,
      handleButtonClick: () => {},
      buttonLabel: EMPTY_STRING,
    },
    isTransferButton = {
      isVisible: false,
      handleButtonClick: () => {},
      buttonLabel: EMPTY_STRING,
    },
  } = props;
  const navigate = useNavigate();

  const handleBackNavigationClick = () => {
    showDraftModal();
    if (isTransactionComplete) {
      updateTransactionData(
        transactionDefaultData,
        SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
      );
    }
    if (backNavigation.navigationMessage) {
      customToast(backNavigation.navigationMessage, toastType.ERROR);
    } else {
      if (backNavigation?.gridState) {
        navigate(createCompanyDynamicUrl(backNavigation.route), {
          state: {
            gridState: backNavigation?.gridState,
            scrollRef: backNavigation?.scrollRef,
          },
        });
      } else {
        navigate(createCompanyDynamicUrl(backNavigation.route));
      }
    }
  };

  const handleSaleButtonClick = () => {
    navigate(
      createCompanyDynamicUrl(
        routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
      )
    );
  };

  const handleTradeButtonClick = () => {
    navigate(
      createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_TRADE)
    );
  };

  return (
    <div className="container-fluid mt-2 mb-2 topbar" key={key}>
      <div className="row m-0">
        <div className="col-md-12 container-fluid d-flex align-items-center px-0">
          <div className="row w-100 m-0">
            <div className="col-sm-6 px-0  topbar-title-container">
              {backNavigation.isVisible ? (
                <div
                  className="cursor-pointer d-flex justify-content-center align-items-center"
                  onClick={handleBackNavigationClick}
                >
                  <BackArrowIcon className="cursor-pointer" />
                  <h1 className="p-0 m-0 topbar-title text-nowrap">{title}</h1>
                </div>
              ) : (
                <h1 className="p-0 m-0 topbar-title text-nowrap">{title}</h1>
              )}
              {countChip === true ? (
                <div className="customer-count-chip text-nowrap">{`Total ${totalCustomers}`}</div>
              ) : (
                ""
              )}
              {sellTradeToggleButton && (
                <div className="topbar-toggle-button-wrapper">
                  <button
                    type="button"
                    className={`topbar-toggle-button ${
                      isNewSale && "active-Button"
                    }`}
                    onClick={() => handleSaleButtonClick()}
                  >
                    New Sale
                  </button>
                  <button
                    type="button"
                    className={`topbar-toggle-button ${
                      !isNewSale && "active-Button"
                    }`}
                    onClick={() => handleTradeButtonClick()}
                  >
                    New Trade
                  </button>
                  <div
                    className={`topbar-toggle-button-background ${
                      !isNewSale && "new-trade-active"
                    }`}
                  ></div>
                </div>
              )}
              {isNewSalePayment && (
                <div className="d-flex justify-content-center align-items-center ms-3 text-nowrap">
                  <div className="item-count-chip">{totalCartItems} Items</div>
                  {typeof handleParkSale === "function" && (
                    <Button
                      type="button"
                      label={buttonNameConstants.PARK_SALE}
                      buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                      handleClick={handleParkSale}
                      isDisabled={isParkSaleDisabled}
                    />
                  )}
                </div>
              )}
              {isDismissAll && (
                <div className="d-flex justify-content-center align-items-center ms-3 text-nowrap">
                  <Button
                    type="button"
                    label={buttonNameConstants.DISMISS_ALL}
                    buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                    handleClick={handleDismissAllClick}
                  />
                </div>
              )}
            </div>

            <div className="col-sm-6 px-0 d-flex justify-content-end align-items-center gap-2">
              {importCsvButton && (
                <Button
                  label={buttonNameConstants.IMPORT_CSV}
                  buttonType={buttonTypeConstants.LIGHT_PURPLE}
                  IconImage={ImportCSVIcon}
                  handleClick={handleImportCsvClick}
                />
              )}
              {isGhostButton && isGhostButton.isVisible && (
                <Button
                  label={isGhostButton.buttonLabel}
                  buttonType={buttonTypeConstants.GHOST_BUTTON}
                  handleClick={isGhostButton.handleButtonClick}
                />
              )}
              {isEditShopifyPresetsButton &&
                isEditShopifyPresetsButton.isVisible && (
                  <Button
                    label={isEditShopifyPresetsButton.buttonLabel}
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                    handleClick={isEditShopifyPresetsButton.handleButtonClick}
                    isDisabled={isEditShopifyPresetsButton.isDisabled}
                  />
                )}
              {isTransferButton && isTransferButton.isVisible && (
                <Button
                  label={isTransferButton.buttonLabel}
                  buttonType={buttonTypeConstants.GHOST_BUTTON}
                  handleClick={isTransferButton.handleButtonClick}
                />
              )}
              {exportButton && (
                <Button
                  label={label}
                  buttonType={buttonType}
                  IconImage={IconImage}
                  handleClick={handleClick}
                />
              )}
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
